module.exports = __webpack_public_path__ + "img/7_197.b9fa9148.png";